// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1015":"e8546ff6","3759":"bed323d8","5512":"0128618e","6406":"ef2bee9e","7952":"98250a73"}[chunkId] + ".chunk.css";
};